import { render, staticRenderFns } from "./ModalTrigger.vue?vue&type=template&id=4b121abf&"
import script from "./ModalTrigger.vue?vue&type=script&lang=js&"
export * from "./ModalTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports